export default __webpack_public_path__ + "6679da770148fb3ea67a845d420d5c59.svg";